module.exports = __webpack_public_path__ + "resources/animals-864abbcaf8677ce6d38fbd60f696dee8.svg";